import { lazy, type ComponentType, type LazyExoticComponent } from 'react'
import type { View } from '../domain/models'

export interface RouteDefinition {
  component: LazyExoticComponent<ComponentType>
  title: string
  context: string
}

export const routes: Record<View, RouteDefinition> = {
  yard: {
    component: lazy(() => import('../pages/YardPage')),
    title: 'ЖД терминал',
    context: 'Разгрузка составов и работа площадки',
  },
  mechanicFleet: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.ReadinessFleet }))),
    title: 'Техника',
    context: 'Закреплённые машины и состояние',
  },
  mechanicMaterials: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.WorkResourcesPage }))),
    title: 'Материалы',
    context: 'Обеспечение технических работ',
  },
  mechanicEvents: {
    component: lazy(() => import('../pages/EventsPage')),
    title: 'События',
    context: 'Уведомления и изменения',
  },
  operatorMessages: {
    component: lazy(() => import('../pages/EventsPage')),
    title: 'Сообщения',
    context: 'Уведомления по моей технике',
  },
  assistant: {
    component: lazy(() => import('../pages/AssistantPage')),
    title: 'Помощник',
    context: 'Будущие функции',
  },
  notifications: {
    component: lazy(() => import('../pages/EventsPage')),
    title: 'Уведомления',
    context: 'События механизации',
  },
  search: {
    component: lazy(() => import('../pages/SearchPage')),
    title: 'Поиск',
    context: 'Техника, работы и детали',
  },
  profile: {
    component: lazy(() => import('../pages/ProfilePage')),
    title: 'Мой профиль',
    context: 'Доступ и состояние приложения',
  },
  procurement: {
    component: lazy(() => import('../pages/ProcurementPage')),
    title: 'Закупки',
    context: 'Обеспечение операций',
  },
  workorders: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.TechnicalWorksPage }))),
    title: 'Работы механика',
    context: 'Процессы и исполнители',
  },
  imports: {
    component: lazy(() => import('../pages/ImportsPage')),
    title: 'Импорт данных',
    context: 'Сверка исходных форм',
  },
  dashboard: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.ReadinessDashboard }))),
    title: 'Готовность парка',
    context: 'Контроль парка и рисков',
  },
  fleet: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.ReadinessFleet }))),
    title: 'Парк техники',
    context: 'Техническое состояние каждой машины',
  },
  maintenance: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.MaintenancePlan }))),
    title: 'Регламент ТО',
    context: 'Автоматический расчёт по регламенту',
  },
  requests: {
    component: lazy(() => import('../pages/RequestsPage')),
    title: 'Заявки',
    context: 'Назначение ресурсов',
  },
  schedule: {
    component: lazy(() => import('../pages/SchedulePage')),
    title: 'Расписание',
    context: 'Техника и операторы',
  },
  operators: {
    component: lazy(() => import('../pages/OperatorsPage')),
    title: 'Операторы',
    context: 'Допуски и назначения',
  },
  map: { component: lazy(() => import('../pages/MapPage')), title: 'Карта', context: 'Техника и объекты' },
  clients: {
    component: lazy(() => import('../pages/ClientsPage')),
    title: 'Клиенты',
    context: 'Договоры и объекты',
  },
  documents: {
    component: lazy(() => import('../pages/DocumentsPage')),
    title: 'Документы',
    context: 'Загруженные артефакты',
  },
  mechanic: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.MechanicWorkspace }))),
    title: 'Механик',
    context: 'Рабочий кабинет механика',
  },
  client: {
    component: lazy(() => import('../pages/ClientPage')),
    title: 'Кабинет клиента',
    context: 'Заявки клиента',
  },
  resources: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.WorkResourcesPage }))),
    title: 'Обеспеченность',
    context: 'Обеспечение конкретной работы',
  },
  costs: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.ReadinessCosts }))),
    title: 'Стоимость парка',
    context: 'Управленческие затраты',
  },
  fuel: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.FuelControlPage }))),
    title: 'Топливо',
    context: 'Заправки, удельный расход и отклонения',
  },
  history: {
    component: lazy(() =>
      import('../pages/ReadinessPages').then((m) => ({ default: m.ReadinessHistoryPage })),
    ),
    title: 'Техническая история',
    context: 'События и решения',
  },
  operator: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.OperatorWorkspace }))),
    title: 'Моя техника',
    context: 'Полевой кабинет оператора',
  },
  settings: {
    component: lazy(() => import('../pages/ReadinessPages').then((m) => ({ default: m.TechnicalSettings }))),
    title: 'Настройки механизации',
    context: 'Контроль актуальности данных',
  },
}
